const accessSales = {

    REGION_LIST: { name: 'Region', path: '/region-list' },
    ADD_REGION: { name: 'Create Region', path: '/create-region' },
    UPDATE_REGION: { name: 'Edit Region', path: '/edit-region' },
    DELETE_REGION: { name: 'Delete Region', path: '/delete-region' },

    GRADE_LIST: { name: 'Grade', path: '/grade-list' },
    ADD_GRADE: { name: 'Create Grade', path: '/create-grade' },
    UPDATE_GRADE: { name: 'Edit Grade', path: '/edit-grade' },
    DELETE_GRADE: { name: 'Delete Grade', path: '/delete-grade' },

    CUSTOMER_GROUP_LIST: { name: 'Customer Group', path: '/customer-group-list' },
    ADD_CUSTOMER_GROUP: { name: 'Create Customer Group', path: '/create-customer-group' },
    UPDATE_CUSTOMER_GROUP: { name: 'Edit Customer Group', path: '/edit-customer-group' },
    DELETE_CUSTOMER_GROUP: { name: 'Delete Customer Group', path: '/delete-customer-group' },

    CUSTOMER_TYPE_LIST: { name: 'Customer Type', path: '/customer-type-list' },
    ADD_CUSTOMER_TYPE: { name: 'Create Customer Type', path: '/create-customer-type' },
    UPDATE_CUSTOMER_TYPE: { name: 'Edit Customer Type', path: '/edit-customer-type' },
    DELETE_CUSTOMER_TYPE: { name: 'Delete Customer Type', path: '/delete-customer-type' },

    CUSTOMER_LIST: { name: 'Customer', path: '/customer-list' },
    ADD_CUSTOMER: { name: 'Create Customer', path: '/create-customer' },
    UPDATE_CUSTOMER: { name: 'Edit Customer', path: '/edit-customer' },
    CUSTOMER_DETAILS: { name: 'Customer Details', path: '/customer-details' },
    DELETE_CUSTOMER: { name: 'Delete Customer', path: '/delete-customer' },

    CATEGORY_LIST: { name: 'Category', path: '/category-list' },
    ADD_CATEGORY: { name: 'Create Category', path: '/create-category' },
    UPDATE_CATEGORY: { name: 'Edit Category', path: '/edit-category' },
    DELETE_CATEGORY: { name: 'Delete Category', path: '/delete-category' },

    ROUTES_LIST: { name: 'Routes', path: '/routes-list' },
    ADD_ROUTES: { name: 'Create Routes', path: '/create-routes' },
    UPDATE_ROUTES: { name: 'Edit Routes', path: '/edit-routes' },
    ROUTES_DETAILS: { name: 'Routes Details', path: '/routes-details' },
    DELETE_ROUTES: { name: 'Delete Routes', path: '/delete-routes' },

    CUSTOMER_ROUTE_ASSIGNMENT_LIST: { name: 'Customer Route Assignment', path: '/customer-route-assignment-list' },
    ADD_CUSTOMER_ROUTE_ASSIGNMENT: { name: 'Create Customer Route Assignment', path: '/create-customer-route-assignment' },
    UPDATE_CUSTOMER_ROUTE_ASSIGNMENT: { name: 'Edit Customer Route Assignment', path: '/edit-customer-route-assignment' },
    DELETE_CUSTOMER_ROUTE_ASSIGNMENT: { name: 'Delete Customer Route Assignment', path: '/delete-customer-route-assignment' },

    CUSTOMER_SALES_ORDER_LIST: { name: 'Customer Sales Order', path: '/customer-sales-order-list' },
    ADD_CUSTOMER_SALES_ORDER: { name: 'Create Customer Sales Order', path: '/create-customer-sales-order' },
    UPDATE_CUSTOMER_SALES_ORDER: { name: 'Edit Customer Sales Order', path: '/edit-customer-sales-order' },
    DELETE_CUSTOMER_SALES_ORDER: { name: 'Delete Customer Sales Order', path: '/delete-customer-sales-order' },

    DISPATCH_ADVICE_ROUTE_PLANNING: { name: 'Dispatch Advice Route Planning', path: '/dispatch-advice-route-planning' },

    VEHICLE_LIST: { name: 'Vehicle', path: '/vehicle-list' },
    ADD_VEHICLE: { name: 'Create Vehicle', path: '/create-vehicle' },
    UPDATE_VEHICLE: { name: 'Edit Vehicle', path: '/edit-vehicle' },
    DELETE_VEHICLE: { name: 'Delete Vehicle', path: '/delete-vehicle' },

    DISPATCH_PLANNING_LIST: { name: 'Dispatch Planning', path: '/dispatch-planning-list' },
    ADD_DISPATCH_PLANNING: { name: 'Create Dispatch Planning', path: '/create-dispatch-planning' },
    UPDATE_DISPATCH_PLANNING: { name: 'Edit Dispatch Planning', path: '/edit-dispatch-planning' },
    DISPATCH_PLANNING_DETAILS: { name: 'Dispatch Planning Details', path: '/dispatch-planning-details' },
    DELETE_DISPATCH_PLANNING: { name: 'Delete Dispatch Planning', path: '/delete-dispatch-planning' },

    CUSTOMER_CATEGORY_LIST: { name: 'Customer Category', path: '/customer-category-list' },
    ADD_CUSTOMER_CATEGORY: { name: 'Create Customer Category', path: '/create-customer-category' },
    UPDATE_CUSTOMER_CATEGORY: { name: 'Edit Customer Category', path: '/edit-customer-category' },
    DELETE_CUSTOMER_CATEGORY: { name: 'Delete Customer Category', path: '/delete-customer-category' },

    DISPATCH_ADVICE_LIST: { name: 'Dispatch Advice', path: '/dispatch-advice-list' },
    ADD_DISPATCH_ADVICE: { name: 'Create Dispatch Advice', path: '/create-dispatch-advice' },
    DISPATCH_ADVICE_APPROVAL: { name: 'Dispatch Advice Approval', path: '/dispatch-advice-approval' },

    PAYMENT_TERMS_LIST: { name: 'Payment Terms', path: '/payment-terms-list' },
    ADD_PAYMENT_TERMS: { name: 'Create Payment Terms', path: '/create-payment-terms' },
    UPDATE_PAYMENT_TERMS: { name: 'Edit Payment Terms', path: '/edit-payment-terms' },
    DELETE_PAYMENT_TERMS: { name: 'Delete Payment Terms', path: '/delete-payment-terms' },

    DELIVERY_PLANNING_LIST: { name: 'Delivery Planning', path: '/delivery-planning-list' },
    ADD_DELIVERY_PLANNING: { name: 'Create Delivery Planning', path: '/create-delivery-planning' },
    UPDATE_DELIVERY_PLANNING: { name: 'Edit Delivery Planning', path: '/edit-delivery-planning' },
    DELIVERY_PLANNING_DETAILS: { name: 'Delivery Planning Details', path: '/delivery-planning-details' },
    DELETE_DELIVERY_PLANNING: { name: 'Delete Delivery Planning', path: '/delete-delivery-planning' },

    STOCK_TRANSFER_LIST: { name: 'Stock Transfer', path: '/stock-transfer-list' },
    ADD_STOCK_TRANSFER: { name: 'Create Stock Transfer', path: '/create-stock-transfer' },
    DELETE_STOCK_TRANSFER: { name: 'Delete Stock Transfer', path: '/delete-stock-transfer' },

    SALES_TARGET_LIST: { name: 'Sales Target', path: '/sales-target-list' },
    UPDATE_SALES_TARGET: { name: 'Edit Sales Target', path: '/edit-sales-target' },

    MERCHANDISE_RACK_LIST: { name: 'Merchandise Rack', path: '/merchandise-rack-list' },
    ADD_MERCHANDISE_RACK: { name: 'Create Merchandise Rack', path: '/create-merchandise-rack' },
    UPDATE_MERCHANDISE_RACK: { name: 'Edit Merchandise Rack', path: '/edit-merchandise-rack' },
    DELETE_MERCHANDISE_RACK: { name: 'Delete Merchandise Rack', path: '/delete-merchandise-rack' },

    TOUR_PLAN_LIST: { name: 'Tour Plan', path: '/tour-plan-list' },
    ADD_TOUR_PLAN: { name: 'Create Tour Plan', path: '/create-tour-plan' },
    TOUR_PLAN_DETAILS: { name: 'Tour Plan Details', path: '/tour-plan-details' },
    DELETE_TOUR_PLAN: { name: 'Delete Tour Plan', path: '/delete-tour-plan' },

    ADD_RETURN_ITEM: { name: 'Create Return Item', path: '/create-return-item' },

    VAN_STOCK_REPORT_LIST: { name: 'Van Stock Report', path: '/van-stock-report' },

    SALESPERSON_LOCATION: { name: 'Sales Person Location', path: '/sales-person-location' },

}

export default accessSales;